const readMores = [...document.querySelectorAll('.js-readmore')];

readMores.map(readMore => readMore.addEventListener('click', () => {

    const content = readMore.previousElementSibling;

    if(content.hasAttribute('data-open')) {
        content.style.removeProperty('height');
        readMore.innerHTML = readMore.getAttribute('data-more');
        setTimeout(() => {
            content.removeAttribute('data-open', '');
        }, 300);
    } else {
        content.setAttribute('data-open', '');
        content.style.height = content.scrollHeight + 'px';
        readMore.innerHTML = readMore.getAttribute('data-less');
    }

}));